function copyViaTextarea(text) {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    try {
        return document.execCommand("copy");
    }
    finally {
        document.body.removeChild(el);
    }
}
export async function copyTextToClipboard(text) {
    let writeTextFailure = "navigator.clipboard unavailable";
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        }
        catch (err) {
            writeTextFailure = `writeText rejected: ${err}`;
        }
    }
    if (!copyViaTextarea(text)) {
        throw new Error(`Clipboard copy failed (${writeTextFailure}; execCommand returned false)`);
    }
}
export async function copyPendingTextToClipboard(textPromise) {
    if (navigator.clipboard?.write && typeof ClipboardItem !== "undefined") {
        try {
            const item = new ClipboardItem({
                "text/plain": textPromise.then((text) => new Blob([text], { type: "text/plain" })),
            });
            await navigator.clipboard.write([item]);
            return;
        }
        catch {
        }
    }
    await copyTextToClipboard(await textPromise);
}
